import React, { useEffect } from 'react'
import Header from './header';
import Footer from './footer';
import { Outlet } from 'react-router-dom';
import { Navbar } from './navbar';
import { SubElements } from './subElements';

export const MainLayout = () => {
    useEffect(() => {
        const html = document.documentElement;
        html.setAttribute('data-layout', 'vertical');
        html.setAttribute('data-sidebar', 'dark');
    }, []);

    return (
        <>
   
        <Header />
            <Navbar/>
            <main>
                <Outlet />
            </main>
            <SubElements/>
            <Footer />
 
        </>
    )
}
